import cx from 'classnames';
import { InputFormItem } from '@jjj/components';
import { t } from '../../../i18n';

const DevelopmentFields = ({
  isGoogleLogin,
  apiUrl,
  wsUrl,
  organizationCode,
  onInputChange,
  onFakeLogin,
  isReview,
}) => {
  return (
    <>
      <InputFormItem
        labelName={t('dash.signIn.api_url_label')}
        value={apiUrl}
        onChange={event => onInputChange({ apiUrl: event.target.value })}
        className={cx({ 'mb-5': !isGoogleLogin })}
        onPressEnter={onFakeLogin}
        data-cy="signin-api-url-input"
      />
      <InputFormItem
        labelName={t('dash.signIn.socket_url_label')}
        value={wsUrl}
        onChange={event => onInputChange({ wsUrl: event.target.value })}
        className={cx({ 'mb-5': !isGoogleLogin })}
        data-cy="signin-socket-url-input"
      />
      {isReview && (
        <InputFormItem
          labelName={t('dash.signIn.organization_code_label')}
          value={organizationCode}
          onChange={event => onInputChange({ organizationCode: event.target.value })}
          className={cx({ 'mb-5': !isGoogleLogin })}
          data-cy="signin-organization-code-url-input"
        />
      )}
    </>
  );
};

export default DevelopmentFields;
